// Lib
import React from 'react';

// Components
import Order from './Order';
import TableRow from './TableRow';
import RecurringOrderCard from '../Cards/RecurringOrderCard';
import VirtualizedTable from '../../VirtualizedTable';
import VirtualizedList from '../../VirtualizedList';
import OuterElementType from '../../VirtualizedList/OuterElementType';

// Hooks
import useUI from '../../../hooks/useUI';
import useRecurringOrderCellReducer from '../../../pages/OrderHistory/hooks/useRecurringOrderCellReducer';
import useOrderCellReducer from '../../../pages/OrderHistory/hooks/useOrderCellReducer';

// Constants
import {
  ordersHistoryColumns,
  recurringOrdersColumns,
} from '../../../constants/orderHistory';

// Styles
import {
  useOrdersHistoryStyles,
  useRecurringOrdersStyles,
} from './OrderListStyles';

const OrderList = ({ orders, isRecurring, isKiteUser }) => {
  const { isDesktopMode } = useUI();
  const { classes: recurringOrdersClasses } = useRecurringOrdersStyles({
    isKiteUser,
  });
  const { classes: ordersHistoryClasses } = useOrdersHistoryStyles({
    isKiteUser,
  });

  if (!orders?.length) {
    return <></>;
  }

  return isDesktopMode ? (
    <VirtualizedTable
      styles={isRecurring ? recurringOrdersClasses : ordersHistoryClasses}
      columns={isRecurring ? recurringOrdersColumns : ordersHistoryColumns}
      items={orders}
      collapsibleTable={!isRecurring}
      TableRow={TableRow}
      useCellsReducers={
        isRecurring ? useRecurringOrderCellReducer : useOrderCellReducer
      }
      rowHeight={72}
      rowGap={16}
    />
  ) : (
    <VirtualizedList
      itemPropName="order"
      OuterElementType={OuterElementType}
      RowComponent={isRecurring ? RecurringOrderCard : Order}
      items={orders}
      itemCount={orders.length}
      rowHeight={
        isRecurring
          ? { tablet: 187, landscape: 140, mobile: 162 }
          : { tablet: 188, landscape: 166, mobile: 196 }
      }
      rowGap={{ tablet: 20, mobile: 16 }}
    />
  );
};

export default OrderList;
